import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    initiatief: [],
    labels: [],
    selectedId: 0,
    selectedSector: [],
    gekozenInitiatief: [],
    pageNumber: 1,
		selectedYears: [],
		years: [],
    _initiatives: [],
    _selectedInitiative: {},
    _filteredInitiatives: []
  },

  plugins: [createPersistedState({storage: window.sessionStorage})],

  mutations: {
    setInitiatief(state, payload) {
      state.initiatief = payload;
    },
    setLabels(state, payload) {
      state.labels = payload;
    },
    setSelectedId(state, payload) {
      state.selectedId = payload;
    },    
    setSelectedSector(state, payload) {
      state.selectedSector = payload;
    },
    
    setPageNumber(state, payload) {
      state.pageNumber = payload;
    },

    setSelectedInitiative(state, payload) {
      state._selectedInitiative = payload;
    },
    setInitiatives(state, payload) {
      state._initiatives = payload;
    },
    setFilteredInitiatives(state, payload) {
      state._filteredInitiatives = payload;
    },
		setSelectedYears(state, payload) {
			state.selectedYears = payload
		},
		setAvailableYears(state, payload) {
			state.years = payload;
		} 		    
  },
  actions: {
    axiosLaadLabels({ commit }, payload) {
      commit("setLabels", payload);
    },
    axiosLaadInitiatieven({ commit }, payload) {
      commit("setInitiatief", payload);
    },

    FETCH_INITIATIVES: (state) => {
      axios.get(
        process.env.VUE_APP_INITIATIEVEN_URL
        ).then(response => {
          return response.data.sort((a, b) => (a.naam.toLowerCase() > b.naam.toLowerCase()) ? 1 : (a.naam === b.naam) ? ((a.size > b.size) ? 1 : -1) : -1 );
        }).then(response => {
          response.forEach(initiatief => {
            if (initiatief.plaatsnaam === '\'S-GRAVENHAGE') {
              initiatief.plaatsnaam_alternatief = 'DEN HAAG'
            }
            if (initiatief.plaatsnaam === 'DEN HAAG') {
              initiatief.plaatsnaam_alternatief = '\'S-GRAVENHAGE'
            }
            if (initiatief.plaatsnaam === '\'S-HERTOGENBOSCH') {
              initiatief.plaatsnaam_alternatief = 'DEN BOSCH'
            }
            if (initiatief.plaatsnaam === 'DEN BOSCH') {
              initiatief.plaatsnaam_alternatief = '\'S-HERTOGENBOSCH'
            }
          })

          state.commit("setInitiatives", response);  
          state.commit("setFilteredInitiatives", response);

					const yearsInFeed = [...new Set(response.map(({datumtijdOpgevoerd}) => Number(datumtijdOpgevoerd.split('-')[0])))]
					.sort((a, b) => b - a) // sort by years
					.slice(0, 3); // max years

					state.commit('setAvailableYears', yearsInFeed);
					state.commit('setSelectedYears', [yearsInFeed[0]]);
					state.commit('setPageNumber', 1);

          return response;
        }).catch(error => console.log(error));      
    },

    SELECT_INITIATIVE: (state, initiative) => state.commit("setSelectedInitiative", initiative),

  },
  getters: {
    initiatives: state => state._initiatives ? state._initiatives : [],
    filteredInitiatives: state => {
			if (state.selectedYears.length > 0) {
			return state._filteredInitiatives ? state._filteredInitiatives.filter((initiative => state.selectedYears.some(year => initiative.datumtijdOpgevoerd.includes(year)))) : []
			} return []
		},
    selectedInitiative: state => state._selectedInitiative,
    selectedYears: state => state.selectedYears ? state.selectedYears : [],
    labels: state => (state.labels ? state.labels : []),
    gekozenInitiatief: state => id => {
      state.initiatieven.length > 0
        ? state.initiatieven.find(
            initiatief => initiatief.initiatiefId === id
          )
        : [] },
    initiatief: state => (state.initiatief ? state.initiatief : []),
    selectedId: state => (state.selectedId ? state.selectedId : 0),
    selectedSector: state => (state.selectedSector ? state.selectedSector : []),
    pageNumber: state => (state.pageNumber ? state.pageNumber : 1)
  }
});
